import React from 'react';
import { useSelector } from 'react-redux';
import { selectAccountById } from 'store/accounts';

import { Grid, GridCell, Text } from 'shared';

import styles from './UserBadge.module.scss';
import { RootStore } from 'store/reducer';

type UserBadgeProps = {
  id: string;
};

const UserBadge = ({ id }: UserBadgeProps) => {
  const account = useSelector((state: RootStore) =>
    selectAccountById(state, id)
  );

  const getInitials = () => {
    const initials =
      account.firstName || account.lastName
        ? `${account.firstName ? account.firstName.charAt(0) : ''}${
            account.lastName ? account.lastName.charAt(0) : ''
          }`
        : account.email.charAt(0);
    return initials.toUpperCase();
  };

  return (
    <Grid gutters="s" valign="center">
      <GridCell>
        <div className={styles.Circle}>{getInitials()}</div>
      </GridCell>
      <GridCell>
        <div className={styles.Meta}>
          {(account.firstName || account.firstName) && (
            <Text weight="semibold">
              {account.firstName}
              {account.firstName && account.lastName && ' '}
              {account.lastName}
            </Text>
          )}
          <Text>{account.email}</Text>
        </div>
      </GridCell>
    </Grid>
  );
};

export default UserBadge;
